module.exports = __webpack_public_path__ + "img/sparta-praha.f829bbad.png";